import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import BusinessReducer from "./business/reducer";


const rootReducer = combineReducers({
    Layout: LayoutReducer,
    Business: BusinessReducer,

});
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;